import React, { useContext } from 'react';

import useUrlForTopic from 'components/data-containers/Overview/shared/utils/useUrlForTopic';
import useMedia from 'hooks/useMedia';

import { EntityContext } from 'context/entityContext';

import OverviewContainer from 'components/Overview/Container/Container';
import ShortFormVideoKPIs from './ShortFormVideoKPIs';

const ShortFormVideoPerformance: React.FC<any> = () => {
  const ctx = useContext(EntityContext);
  const isMobile = useMedia('(max-width: 50em)');

  return (
    <OverviewContainer
      filtersToShow={['country', 'region', 'customRegion', 'platform']}
      title="Short Form Video"
      linkTo={useUrlForTopic('social/shortFormVideo')}
      isNotPadded
      isMobile={isMobile}
    >
      <ShortFormVideoKPIs {...ctx} />
    </OverviewContainer>
  );
};

export default ShortFormVideoPerformance;
